<<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Ajouter un IBAN</strong>
          </div>
            <b-form-group
              label="IBAN"
              label-for="iban"
            >
              <b-form-input id="iban" type="text" :class="{hasError: errors.iban !== ''}" v-model="iban"></b-form-input>
              <span class="field-error">{{ errors.iban }}</span>
            </b-form-group>

            <b-form-group
              label="SIREN"
              label-for="siren"
            >
              <b-form-input id="siren" type="text" :class="{hasError: errors.siren !== ''}" v-model="siren"></b-form-input>
              <span class="field-error">{{ errors.siren }}</span>
            </b-form-group>

            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des IBAN
              </b-button>
              <b-button type="button" @click="create" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'
import {espaceRPARules, hasRule} from '../../../utils/rulesHelper'
import IbanValidator from 'iban/iban.js';

export default {
  data() {
    return {
      rules: espaceRPARules,
      iban : '',
      siren: '',
      errors: {
        iban: '',
        siren: ''
      }
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
   create() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let errorText = '';
        let dataPost = {};

        dataPost.iban = this.iban;
        dataPost.siren = this.siren;

        this.$axios
          .post("/espaceRPA/ibanSiren/store", dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Création avec succès', text:'L IBAN a bien été créé',showConfirmButton: false, timer: 5000})
              this.$router.push({ path: '/suivi-cotisations/iban-siren/' })
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            if (error.response && error.response.status === 406) {
              errorText = "L\'IBAN saisie existe déjà pour ce SIREN"
            }else{
              errorText = 'Un problème est survenu, merci de contacter le support';
            }
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:errorText,showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/suivi-cotisations/iban-siren/' })
    },
    validateData () {
      this.clearErrors();
      this.siren = this.siren.replace(/\s/g, '');
   
      let valid = true;

      if (this.iban === "") {
        this.errors.iban = "L'IBAN est obligatoire";
        valid= false;
      } else if (!IbanValidator.isValid(this.iban)) {
         valid = false
         this.errors.iban  = "L'IBAN est invalide"
      }

      if (this.siren === "") {
        this.errors.siren = "Le SIREN est obligatoire";
        valid= false;
      } else if (this.siren.length != 9) {
         valid = false
         console.log(this.siren.length);
         this.errors.siren  = 'Veuillez entrer un SIREN de 9 chiffres'
      }else{
        if(this.checkSiren() == false){
          valid = false;
          this.errors.siren  = 'Le SIREN est invalide.'
        }
      }
      
      return valid;
    },
    clearErrors() {
      this.errors.iban = "";
      this.errors.siren = "";
    },
    checkSiren(){
      let siren = this.siren;
      
      if ( (siren.length != 9) || (isNaN(siren)) )
        return false;
      else {
        var somme = 0;
        var tmp;
        for (var cpt = 0; cpt<siren.length; cpt++) {
          if ((cpt % 2) == 1) { // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
            tmp = siren.charAt(cpt) * 2; // On le multiplie par 2
            if (tmp > 9) 
              tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
          }
          else
            tmp = siren.charAt(cpt);
          somme += parseInt(tmp);
        }
        if ((somme % 10) == 0)
          return true;
        else
          return  false;
      }
      return false;
    }
  }
}
</script>
